import { DealModel } from './deal.model';
import { DealServiceItemModel} from './deal-service-item.model';
import { DealTermModel } from './deal-term.model';

export class DealsWizardModel extends DealModel {
    terms: DealTermModel[];
    dealServiceItems: DealServiceItemModel[];
    hasError: boolean;
    errorMessage: string;
    fileToUpload: File;
}


// WEBPACK FOOTER //
// ./src/app/_models/deals-wizard.model.ts